import React from 'react';
import { NotesOutlined } from '@mui/icons-material';
import { RichText, RichTextPropsSchema } from './RichText';
import RichTextSidebarPanel from './RichTextSidebarPanel';
export default {
    label: 'RichText',
    icon: React.createElement(NotesOutlined, null),
    type: 'RichText',
    defaultData: {
        props: { text: '<p>Rich Text <strong>Content</strong></p>' },
        style: {
            padding: { top: 16, bottom: 16, left: 24, right: 24 },
            fontWeight: 'normal',
            fontSize: 16,
        },
    },
    SidebarPanel: RichTextSidebarPanel,
    Component: RichText,
    schema: RichTextPropsSchema,
};
//# sourceMappingURL=index.js.map